var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconSportBadminton24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_sport_badminton24x24",
    transform: "translate(1513.013 574)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23759",
    transform: "translate(-1513.013 -574)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23637",
    fill: "#999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45940",
    d: "M-1509.105-557.389c-.089-.177-.266-.354-.354-.531h0a1.22,1.22,0,0,0-.266-.354h0l-.089-.089a4.038,4.038,0,0,0-1.062-1.062c-.089,0-.089-.089-.177-.089-.177-.177-.354-.266-.531-.443-.089-.089-.177-.089-.354-.177a1.934,1.934,0,0,1-.443-.266,2.558,2.558,0,0,0,0,3.365l.266.266c.089.089.177.089.266.177a.309.309,0,0,1,.177.089,3.147,3.147,0,0,0,.885.177h.708c.089,0,.177-.089.266-.089s.089-.089.177-.089.177-.089.266-.089.177-.089.266-.177h0a.087.087,0,0,0,.089-.089h0C-1508.928-557.212-1509.017-557.3-1509.105-557.389Z",
    transform: "translate(1513.013 572.327)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45941",
    d: "M-1504.115-567.073l3.01-3.365V-571.5l-1.328.177L-1505-567.87A7.977,7.977,0,0,1-1504.115-567.073Z",
    transform: "translate(1512.231 573.714)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45942",
    d: "M-1504.712-572.849l-.354-1.151-1.151.354-1.682,3.63a9.865,9.865,0,0,1,1.063.708Z",
    transform: "translate(1512.509 574)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45943",
    d: "M-1505.415-568.2l2.568-3.453V-572.8l-1.328.177-2.125,3.63C-1506.034-568.727-1505.68-568.461-1505.415-568.2Z",
    transform: "translate(1512.354 573.863)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45944",
    d: "M-1502.915-565.861l3.276-3.1.089-1.24-1.24.177-3.011,3.365A7.968,7.968,0,0,1-1502.915-565.861Z",
    transform: "translate(1512.119 573.532)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45945",
    d: "M-1501.792-564.6l3.63-2.745V-568.5h-1.062l-3.276,3.1A5.732,5.732,0,0,1-1501.792-564.6Z",
    transform: "translate(1512.036 573.324)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45946",
    d: "M-1500.7-563.081l3.542-2.125.177-1.417-.885-.177-3.63,2.745A2.767,2.767,0,0,1-1500.7-563.081Z",
    transform: "translate(1511.922 573.116)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45947",
    d: "M-1496.758-564.7l-3.542,2.125c.266.354.443.708.708,1.063l3.63-1.682.177-1.151Z",
    transform: "translate(1511.784 572.861)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45948",
    d: "M-1506.9-558.824c.089.177.177.266.266.443l5.932-2.745a9.249,9.249,0,0,0-.708-.974Z",
    transform: "translate(1512.441 572.522)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45949",
    d: "M-1507.226-559.4l5.49-3.276a6.752,6.752,0,0,1-.708-.974l-1.24.885s-.089.089-.089,0c-.089,0-.089,0-.177-.089s0-.177,0-.266h0l1.151-.885c-.266-.266-.443-.531-.708-.8l-4.693,4.339.443.443C-1507.492-559.753-1507.4-559.576-1507.226-559.4Z",
    transform: "translate(1512.566 572.859)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45950",
    d: "M-1504.807-566.3c-.266-.266-.62-.531-.885-.8l-3.807,5.136a2.348,2.348,0,0,0,.531.443l.531.531,4.693-4.339-.8-.8-.885.974-.089.089a.087.087,0,0,1-.089-.089.166.166,0,0,1,0-.266h0Z",
    transform: "translate(1512.681 573.139)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45951",
    d: "M-1509.96-562.382l3.807-5.136c-.354-.266-.62-.531-.885-.708l-.8,1.417c0,.089-.089.089-.177.089h-.089a.325.325,0,0,1-.089-.266h0l.8-1.505c-.531-.354-.974-.62-1.062-.708l-2.745,5.932a4.92,4.92,0,0,1,.708.531A5.392,5.392,0,0,0-1509.96-562.382Z",
    transform: "translate(1512.805 573.397)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45952",
    d: "M-1507.938-558.812c-.177-.177-.266-.354-.443-.531a7.081,7.081,0,0,0-1.151-1.151,13.243,13.243,0,0,0-1.151-.974.087.087,0,0,1-.089-.089,6.02,6.02,0,0,1-.62-.443h0l-.354.443h0l-.354.443a.087.087,0,0,1,.089.089,1.929,1.929,0,0,1,.708.443l.089.089c.266.177.443.354.62.443l.089.089a10.61,10.61,0,0,1,.974,1.063l.089.089c.089.177.177.266.266.443v.089a5.08,5.08,0,0,1,.354.62.309.309,0,0,0,.089.177h0l.443-.266h0l.531-.354h0a.735.735,0,0,0-.177-.708Z",
    transform: "translate(1512.908 572.51)"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconSportBadminton24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_sport_badminton24x24.a88fdec208d69c4338e71ec44b87b4f3.svg";